import { API_ENDPOINT, STAGE_API_ENDPOINT, STAGE_MODE_HASHS } from 'settings';

export const getApiEndpoint = (): string => {
  const stageMode = new URLSearchParams(window.location.search).get('stageMode');
  return stageMode && STAGE_MODE_HASHS.includes(stageMode) ? STAGE_API_ENDPOINT : API_ENDPOINT;
};
